import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getRoster } from '../utils/api';
import { formatDate } from '../utils/date';
import './Roster.css';

const Roster = () => {
    const navigate = useNavigate();
    const [roster, setRoster] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchRoster = async () => {
            try {
                const response = await getRoster();
                setRoster(response.data);
                setLoading(false);
            } catch (error) {
                console.error('Error fetching roster:', error);
                setLoading(false);
            }
        };

        fetchRoster();
    }, []);

    if (loading) {
        return <div>Loading...</div>;
    }

    return (
        <div className="roster-container">
            <div className="header">
                <h1>Roster</h1>
            </div>
            <table className="roster-table">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Type</th>
                    </tr>
                </thead>
                <tbody>
                    {roster.map(term => (
                        <React.Fragment key={term.id}>
                            <tr className="term-header-row">
                                <th colSpan="3">{term.name} <span className="term-dates">{formatDate(term.start_date)} - {formatDate(term.end_date)}</span></th>
                            </tr>
                            {term.levels.map(level => (
                                <React.Fragment key={level.id}>
                                    <tr className="level-header-row">
                                        <th colSpan="3">{level.name}</th>
                                    </tr>
                                    {level.streams.map(stream => (
                                        <React.Fragment key={stream.id}>
                                            <tr className="stream-header-row">
                                                <th colSpan="3">{stream.name} ({stream.student_count} students)</th>
                                            </tr>
                                            {stream.students && stream.students.map(student => (
                                                <tr key={student.id} onClick={() => navigate(`/students/${student.id}`)} className="student-row">
                                                    <td>{student.first_name} {student.last_name}</td>
                                                    <td>{student.email}</td>
                                                    <td>{student.type}</td>
                                                </tr>
                                            ))}
                                        </React.Fragment>
                                    ))}
                                </React.Fragment>
                            ))}
                        </React.Fragment>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default Roster;
